import BootstrapSwitchButton from "bootstrap-switch-button-react";
import React from "react";
import { Fragment } from "react/cjs/react.production.min";

const texts = ["воспросов", "вопрос", "вопроса", "вопроса", "вопроса"];
export class Filter extends React.Component {
  constructor(props) {
    super(props);
    this.a = [1, 2, 1, 0, 2, 0, 2, 0, 2, 2, 2, 2];
    this.filters = props.filters;
    this.state = { nextEnabled: false, final: false, result: "" };
  }

  calcResult() {
    var res = 0;
    for (var i = 0; i < this.filters.length; i++) {
      if (this.filters[i].val == this.a[i]) res++;
    }

    var txtRes = "Ты ответил верно на " + res + " ";
    if (res <= 4) txtRes += texts[res];
    else txtRes += "вопросов";
    txtRes += " из " + this.filters.length;

    var p = res / this.filters.length;
    if (p > 0.8) txtRes += ". Это отличный результат, молодец!";
    if (p > 0.4 && p <= 0.8) txtRes += ". Это хороший результат, молодец!";
    if (p <= 0.4) txtRes += ". Нам стоит разобраться в финансовой грамотности!";
    return txtRes;
  }

  switchFilter(currentIndex, nextIndex) {
    if (this.filters.length > nextIndex && nextIndex > 0) {
      var current_fs = document.getElementById("mobFilter" + this.filters[currentIndex].id);
      var next_fs = document.getElementById("mobFilter" + this.filters[nextIndex].id);
      next_fs.style.display = "block";
      current_fs.style.display = "none";
    }
  }

  fnext(currentIndex) {
    this.switchFilter(currentIndex, currentIndex + 1);
  }

  fprev(currentIndex) {
    this.switchFilter(currentIndex, currentIndex - 1);
  }

  render() {
    return (
      <section id="mobile-filter1" className="pt-5">
        <div className="col-lg-11 mx-auto">
          <div className="px-0 pb-0 mb-3">
            <div className="row">
              <div className="col-md-12 mx-0">
                <div id="msform">
                  {this.state.final ? (
                    <Fragment>
                      <div className="card shadow">
                        <div className="card-body">
                          <div className="row pt-3 pb-3 pl-5 pr-4 align-items-center">
                            <div className="col-12">
                              <h1 className="text-center">Твой результат:</h1>
                              <h5 className="text-center pt-3">{this.state.result}</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="text-center pt-4">
                        <button
                          className={"next action-button enabled"}
                          onClick={() => {
                            window.open("https://abc.smeshariki.ru");
                          }}
                        >
                          Дальше<img src="assets/images/arrow.png"></img>
                        </button>
                      </div>
                    </Fragment>
                  ) : (
                    this.filters.map((item, index) => {
                      return (
                        <fieldset id={"mobFilter" + item.id}>
                          <div className="card shadow">
                            <div className="card-body wide">
                              <div className="row pt-3 pb-3 pl-5 pr-4 align-items-center">
                                <div className="col-8">
                                  <h5 className="row card-title">{item.title}</h5>
                                  {item.vals.map((val, idx) => {
                                    return (
                                      <div
                                        className={
                                          this.a[index] == idx && this.state.showAnswer
                                            ? "row form-check pt-2 pb-2 w-100 answer_right"
                                            : item.val == idx && this.state.showAnswer
                                            ? "row form-check pt-2 pb-2 w-100 answer_wrong"
                                            : "row form-check pt-2 pb-2 w-100"
                                        }
                                      >
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name="radioWide"
                                          id={"radioWide" + item.id + "_" + idx}
                                          disabled={this.state.showAnswer}
                                          onChange={(checked) => {
                                            item.val = idx;
                                            this.setState({ nextEnabled: true });
                                          }}
                                        ></input>
                                        <label className="form-check-label" htmlFor={"radioWide" + item.id + "_" + idx}>
                                          {val}
                                        </label>
                                      </div>
                                    );
                                  })}
                                </div>
                                <div className="col-4">
                                  <img src={item.img} className="img-fluid"></img>
                                </div>
                              </div>
                            </div>{" "}
                            <div className="card-body mobile">
                              <div className="row pt-1 pb-3 pl-5 pr-4 align-items-center">
                                <div className="text-center w-100 pb-3">
                                  <img src={item.img} className="img-fluid"></img>
                                </div>
                                <h5 className="row card-title">{item.title}</h5>
                                {item.vals.map((val, idx) => {
                                  return (
                                    <div
                                      className={
                                        this.a[index] == idx && this.state.showAnswer
                                          ? "row form-check pt-2 pb-2 w-100 answer_right"
                                          : item.val == idx && this.state.showAnswer
                                          ? "row form-check pt-2 pb-2 w-100 answer_wrong"
                                          : "row form-check pt-2 pb-2 w-100"
                                      }
                                    >
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="radioMobile"
                                        id={"radioMobile" + item.id + "_" + idx}
                                        disabled={this.state.showAnswer}
                                        onChange={(checked) => {
                                          item.val = idx;
                                          this.setState({ nextEnabled: true });
                                        }}
                                      ></input>
                                      <label className="form-check-label" htmlFor={"radioMobile" + item.id + "_" + idx}>
                                        {val}
                                      </label>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>{" "}
                          </div>{" "}
                          <div className="text-center pt-4">
                            <button
                              disabled={!this.state.nextEnabled || this.state.showAnswer}
                              className={"next action-button " + (this.state.nextEnabled ? "enabled" : "disabled")}
                              onClick={() => {
                                var nextState = { nextEnabled: false, final: false, result: 0, showAnswer: true };
                                if (index >= this.filters.length - 1) {
                                  var res = this.calcResult();
                                  nextState.final = true;
                                  nextState.result = res;
                                }
                                this.setState({ nextEnabled: false, final: false, result: 0, showAnswer: true });
                                setTimeout(() => {
                                  nextState.showAnswer = false;
                                  this.setState(nextState);
                                  if (!nextState.final) this.fnext(index);
                                }, 1000);
                              }}
                            >
                              Дальше<img src="assets/images/arrow.png"></img>
                            </button>
                          </div>
                        </fieldset>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <script>$('.btn-toggle').bootstrapSwitch();</script>
      </section>
    );
  }
}
